import React, { ReactNode } from 'react';
import clsx from 'clsx';

import { useStyles } from './typography.styles';

export interface DangerProps {
  children?: ReactNode; // PropTypes.node,
}

export const Danger = (props: DangerProps) => {
  const classes = useStyles();
  const { children } = props;
  return (
    <div className={clsx(classes.defaultFontStyle, classes.dangerText)}>
      {children}
    </div>
  );
};
